module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "index-bannerAndSearch"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "index-search"
  }, [_c('div', {
    staticClass: "index-headerBox",
    on: {
      "click": _vm.toUser
    }
  }, [(_vm.userInfo.headimgurl) ? _c('img', {
    staticStyle: {
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "src": _vm.userInfo.headimgurl,
      "alt": ""
    }
  }) : _c('img', {
    staticStyle: {
      "width": "20px",
      "border-radius": "0"
    },
    attrs: {
      "src": require("../assets/img/index/header-default.svg"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkPendingNum > 0),
      expression: "checkPendingNum > 0"
    }],
    staticClass: "index-checkPending",
    on: {
      "click": function($event) {
        return _vm.toNewPage('https://erp.newrank.cn/media/examine/project')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/index/header-toAde.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("待审核"), _c('span', {
    staticStyle: {
      "color": "#ff7800",
      "margin": "0 3px"
    }
  }, [_vm._v(_vm._s(_vm.checkPendingNum))]), _vm._v("个")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moreNews.length),
      expression: "moreNews.length"
    }],
    staticClass: "index-news"
  }, [_c('img', {
    staticClass: "news-leftTitle",
    attrs: {
      "src": require("../assets/img/index/icon-notice.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-container"
  }, [_c('transition', {
    staticClass: "inner-container2",
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('p', {
    key: _vm.text.id,
    staticClass: "text2",
    staticStyle: {
      "max-height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.toNewPage(_vm.text.url)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.text.val && _vm.text.val.length > 22 ?
    _vm.text.val.substring(0, 22) + "..." :
    _vm.text.val) + "\n        ")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "news-more",
    on: {
      "click": _vm.showMoreNews
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#eee"
    }
  }, [_vm._v("|")]), _vm._v(" more")])]), _vm._v(" "), _c('div', {
    staticClass: "index-searchrow"
  }, [_c('div', {
    staticClass: "search-row"
  }, [_c('div', {
    ref: "searchTypeContainer",
    staticClass: "search-type-container"
  }, [_c('div', {
    staticClass: "search-type-change",
    class: {
      active: _vm.showSearchType
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSearchType.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.searchType === "account" ? "搜账号" : "搜热度") + " \n          "), _c('img', {
    class: {
      'search-type-icon': true,
      'search-type-icon-active': !!_vm.showSearchType
    },
    attrs: {
      "src": require("../assets/img/index/img-jiantou.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "search-type-divider"
  }, [_vm._v("|")]), _vm._v(" "), (_vm.showSearchType) ? _c('div', {
    staticClass: "search-type-option"
  }, [_c('div', {
    staticClass: "search-type-option-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectSearchType('account')
      }
    }
  }, [_vm._v("\n              搜账号\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-option-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectSearchType('trend')
      }
    }
  }, [_vm._v("\n              搜热度\n            ")])]) : _vm._e()])]), _vm._v(" "), _c('img', {
    staticClass: "search-icon",
    attrs: {
      "src": require("../assets/img/index/search.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serachInput),
      expression: "serachInput"
    }],
    staticClass: "search-inputrow",
    attrs: {
      "type": "search",
      "placeholder": _vm.renderTips
    },
    domProps: {
      "value": (_vm.serachInput)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.serachInput = $event.target.value
      }, _vm.changeSerachInput],
      "search": _vm.handleSearch
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.serachInput),
      expression: "!!serachInput"
    }],
    staticClass: "inputBox-clear",
    on: {
      "click": _vm.clearKeyWord
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/search/delete.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    class: {
      'search-btn': true,
      'search-btn-trend': _vm.searchType === 'trend'
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("搜索")])])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "index-linkList"
  }, _vm._l((_vm.linkListData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "linkList-item",
      on: {
        "click": function($event) {
          return _vm.toProduct(item)
        }
      }
    }, [(item.text == '品牌榜') ? _c('OpenWechat', {
      attrs: {
        "className": "wx-open-enter",
        "platform": "sq",
        "isWechatEnvProp": false,
        "path": "pages/Rank/RankList/index"
      }
    }) : _vm._e(), _vm._v(" "), (item.text == '账号榜') ? _c('OpenWechat', {
      attrs: {
        "className": "wx-open-enter",
        "platform": "sq",
        "isWechatEnvProp": false,
        "path": "pages/Rank/RankList/index?production=ranklist"
      }
    }) : _vm._e(), _vm._v(" "), (item.text == '账号榜') ? _c('div', {
      staticClass: "linkList-bangdan-new-day"
    }, [(_vm.bangdanNewStatus == 1) ? _c('img', {
      attrs: {
        "src": require("../assets/img/index/bangdan-day.svg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.bangdanNewStatus == 2) ? _c('img', {
      attrs: {
        "src": require("../assets/img/index/bangdan-week.svg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.bangdanNewStatus == 3) ? _c('img', {
      attrs: {
        "src": require("../assets/img/index/bangdan-month.svg"),
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "linkList-item-icon",
      style: ({
        backgroundColor: item.color
      })
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.text))])], 1)
  }), 0), _vm._v(" "), (_vm.bannerData.length) ? _c('swipe', {
    staticClass: "index-advertisement",
    attrs: {
      "autoplayTime": _vm.autoplayTime,
      "pagination": _vm.pagination
    }
  }, _vm._l((_vm.bannerData), function(item, index) {
    return _c('swipe-item', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.img_url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.toNewPage(item.click_url)
        }
      }
    })])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "index-lnewXList"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "index-lnewXList-box"
  }, _vm._l((_vm.lnewXList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-lnewXList-box-item",
      on: {
        "click": function($event) {
          return _vm.clickNewXItem(item.url)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.bgi,
        "alt": ""
      }
    })])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "index-footer"
  }, [_vm._v("©2023 NEWRANK 沪ICP备14042332号-2")]), _vm._v(" "), (_vm.isPhone && !_vm.isMiniApp) ? _c('div', [(!_vm.isWechatEnv) ? _c('div', {
    staticClass: "open-wechat"
  }, [_vm._v("\n        新榜 | 前往小程序\n        "), _c('OpenWechat', {
    attrs: {
      "className": "wx-open-enter",
      "platform": "sq",
      "isWechatEnvProp": false,
      "path": "pages/Index/index?channel=index_h5"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "open-wechat-position"
  }, [_c('wx-open-launch-weapp', {
    attrs: {
      "ready": true,
      "path": "pages/Index/index?channel=index_h5",
      "appid": "wx550e53f8b403dd49",
      "id": "launch-btn-wechat",
      "env-version": "release"
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n            <style>\n              .openBtn {\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                height: 32px;\n                width: 140px;\n                color: #fff;\n                background: linear-gradient(297deg,#ff7800,#ffb700);\n                border-radius: 16px;\n                font-size: 14px;\n              }\n            </style>\n            <div class=\"openBtn\">新榜 | 前往小程序</div>\n          ")])])], 1)]) : (!_vm.isPhone && !_vm.isMiniApp) ? _c('div', {
    staticClass: "open-web"
  }, [_c('a', {
    attrs: {
      "href": _vm.mainUrl
    }
  }, [_vm._v("新榜 | 前往官网")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notFollowBar),
      expression: "notFollowBar"
    }],
    staticClass: "not-follow-newrank"
  }, [_c('div', {
    staticClass: "not-follow-newrank-close",
    on: {
      "click": _vm.closeNotFollow
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "not-follow-newrank-text",
    on: {
      "click": _vm.notFollow
    }
  }, [_vm._v("\n      尚未关注「新榜服务」，可能会走丢\n    ")])]), _vm._v(" "), _c('Popup', {
    attrs: {
      "codeTitle": _vm.codeTitle,
      "codeImg": _vm.codeImg
    },
    model: {
      value: (_vm.codeShow),
      callback: function($$v) {
        _vm.codeShow = $$v
      },
      expression: "codeShow"
    }
  }), _vm._v(" "), _c('BottomRouter', {
    attrs: {
      "page": "index"
    }
  }), _vm._v(" "), (_vm.moreNewsShow && _vm.moreNews.length > 0) ? _c('MoreNews', {
    attrs: {
      "showData": _vm.moreNews
    },
    on: {
      "hideMoreNews": _vm.hideMoreNews
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-banner"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/img/index/banner.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intelligence-head"
  }, [_c('span', {
    staticClass: "intelligence-head-border"
  }), _vm._v(" "), _c('span', {
    staticClass: "intelligence-head-title"
  }, [_vm._v("短视频直播数据工具")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a7d35e0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 243
// module chunks = 45